import moment from "moment/moment";

const DATE_FIELDS = [
  "created_at",
  "createdAt",
  "captured_at",
  "capturedAt",
  "taken_at",
  "takenAt",
  "updated_at",
  "updatedAt",
];

export const getGalleryItemDate = (item) => {
  const source = [item, item?.media].find((candidate) => DATE_FIELDS.some((key) => candidate?.[key]));
  const field = DATE_FIELDS.find((key) => source?.[key]);
  if (!field) return "";

  const date = moment(source[field]);
  return date.isValid() ? date.format("YYYY-MM-DD") : "";
};

export const filterGalleryItemsByDate = (items, dateFrom, dateTo) => {
  const collection = Array.isArray(items) ? items : [];
  if (!dateFrom && !dateTo) return collection;

  const hasDatedItems = collection.some((item) => getGalleryItemDate(item));
  if (!hasDatedItems) return collection;

  return collection.filter((item) => {
    const itemDate = getGalleryItemDate(item);
    if (!itemDate) return false;
    if (dateFrom && itemDate < dateFrom) return false;
    if (dateTo && itemDate > dateTo) return false;
    return true;
  });
};
